import React from 'react';
import createReactClass from 'create-react-class';
import ReactDOM from 'react-dom';

import events from '../../events/index';
import actions from './actions';

import * as api from './util/SeluxProductsRESTApi';
import MountingRoot from './components/MountingRoot';

document.queryAll('.js-slx-mounting').forEach((element) => {
	actions.loadItems.listen(function (foo) {
		element.classList.add('js-slx-mounting--loading');

		api.getItems(foo)
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				element.classList.remove('js-slx-mounting--loading');
			});
	});

	actions.loadItem.listen(function (foo) {
		element.classList.add('js-slx-mounting--loading');

		api.getItems(foo)
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				element.classList.remove('js-slx-mounting--loading');
			});
	});


	actions.loadAccessoryIdsForItems.listen(function (foo) {
		element.classList.add('js-slx-mounting--loading-accessory-ids');

		api.getAccessoryIdsForItems(foo)
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				// console.log('    \\  loadAccessoryIdsForItems end');
				element.classList.remove('js-slx-mounting--loading-accessory-ids');
				actions.loadAccessoryFacets();
				actions.loadAccessoryCount();
			});
	});

	actions.loadFacets.listen(function (foo) {
		element.classList.add('js-slx-mounting--loading-items');

		api.getFacets(foo)
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				// console.log('     \\ loadFacets end');
				element.classList.remove('js-slx-mounting--loading-items');
			});
	});

	actions.loadAccessoryFacets.listen(function () {
		element.classList.add('js-slx-mounting--loading-items');

		api.getAccessoryFacets()
			.then(this.completed)
			.catch(this.failed)
			.then(() => {
				// console.log('      \\loadAccessoryFacets end');
				element.classList.remove('js-slx-mounting--loading-items');
			});
	});

	const configuration = JSON.parse(element.getAttribute('data-config'));
	const state = JSON.parse(element.getAttribute('data-state'));
	console.log('index configuration', configuration);
	actions.changeConfiguration(configuration);
	actions.initializeMounting(state);

	ReactDOM.render(<React.StrictMode><MountingRoot /></React.StrictMode>, element);
});
